import React from 'react'
import { Fade } from 'react-reveal'
import { withTheme } from 'styled-components'
import { v4 as uuidv4 } from 'uuid'

import { TrifoldWrapper, TrifoldCard } from './SlideTrifold.styles'

const DarkTrifold = ({ theme, cards }) => {
  const colorArr = [
    theme.colors.sTrifold1,
    theme.colors.sTrifold2,
    theme.colors.sTrifold3,
  ]
  return (
    <TrifoldWrapper>
      {cards.map((card, i) => (
        <TrifoldCard key={uuidv4()} bgColor={colorArr[i]} subMax={card.subMax}>
          <Fade right>{card.icon}</Fade>
          {card.head && <h3>{card.head}</h3>}
          <p>{card.sub}</p>
        </TrifoldCard>
      ))}
    </TrifoldWrapper>
  )
}

export default withTheme(DarkTrifold)
